import { render } from "./professionIndex.vue?vue&type=template&id=129a23a3&scoped=true"
import script from "./professionIndex.vue?vue&type=script&lang=js"
export * from "./professionIndex.vue?vue&type=script&lang=js"

import "./professionIndex.vue?vue&type=style&index=0&id=129a23a3&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129a23a3"]])

export default __exports__